import {Component} from '@angular/core';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-upload-inspection-report',
  templateUrl: './upload-inspection-report.component.html',
  styleUrls: ['./upload-inspection-report.component.scss']
})
export class UploadInspectionReportComponent {
  selectedFiles: FileList;

  constructor(private bottomSheetRef: MatBottomSheetRef) {
  }

  onFilesChanged(files: FileList) {
    this.selectedFiles = files;
  }

  save() {
    this.bottomSheetRef.dismiss(this.selectedFiles);
  }

  dismiss() {
    this.bottomSheetRef.dismiss();
  }
}
